/* eslint-disable max-len */
import {
    useMemo,
} from 'react'

import useLabel from 'app/hooks/useLabel'
import {
    getLabelKeyValue,
} from 'app/shared-components/SkyNetTable/hooks/utils/replaceLabels'

import {
    SkyDataGridColumnDefinition,
    ExtendedGridColDef,
    SkyBaseDataSourceProvider,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import renderCell from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/utils/renderCell'
import {
    customEqualsOperator,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/utils/FilterOperators'

const emptyArray = []
/* transform our column definitions to Mui Data Grid column definitions */
const useDataGridColumns = ({
    columnsDef,
    customDataSource,
    filtersUnrelatedToColumns = emptyArray,
}: {
    columnsDef: SkyDataGridColumnDefinition<any>[],
    customDataSource: SkyBaseDataSourceProvider,
    filtersUnrelatedToColumns?: SkyDataGridColumnDefinition<any>[],
}) => {
    const l = useLabel()

    return useMemo(() => {
        const combinedColumns = [
            ...columnsDef,
            ...filtersUnrelatedToColumns,
        ]

        return combinedColumns.map((column): ExtendedGridColDef => {
            return {
                ...column,
                flex: column?.width ? undefined : 1,
                minWidth: column?.minWidth || 100,
                headerName: column.headerName || getLabelKeyValue({
                    l,
                    name: '',
                    labelKey: column.labelKey,
                    id: column.name,
                    labelEntityName: '',
                }),
                field: column.name as string,
                sortable: column.sorting,
                ...renderCell(column),
                filterable: Boolean(column.filterType) && !column.hiddenFromColumns,
                // if we set filterable: false, but add this field to filterModel,
                // then we will get filterRow with disabled remove button and field selector,
                // but Input will ignore disabled and use will be able to change filter value
                filterOperators: customEqualsOperator(customDataSource, column),
            } as ExtendedGridColDef
        })
    }, [
        customDataSource,
        columnsDef,
        filtersUnrelatedToColumns,
        l,
    ])
}

export default useDataGridColumns
